import NumbersGenerator from './components/numbersGenerator/NumbersGenerator'

function App() {
  return (
    <div className="App">
      <NumbersGenerator />
    </div>
  );
}

export default App;